export default __webpack_public_path__ + "fdddb23e13aebd5b7d8673f7ad31d67f.png";